var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 27",
    style: {
      enableBackground: "new 0 0 22 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#060709;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,3.4c-2.1-1.9-4.6-2.9-7.3-2.9c-2.8,0-5.2,1-7.3,2.9c-2.1,1.9-3.2,4.5-3.2,7.7c0,2.1,0.9,4.5,2.6,7.1 c1.7,2.5,4.4,5.3,7.9,8.2c3.5-2.9,6.1-5.7,7.9-8.2c1.8-2.5,2.6-4.9,2.6-7.1C21.5,7.9,20.4,5.3,18.3,3.4z M17.6,16.8 c-1.4,2.1-3.5,4.4-6.3,7L11,24.1l-0.3-0.3c-2.8-2.5-4.9-4.9-6.3-7c-1.4-2.1-2.1-4.1-2.1-5.8c0-2.6,0.9-4.7,2.5-6.4 C6.5,3,8.6,2.2,11,2.2c2.4,0,4.5,0.8,6.2,2.5c1.7,1.7,2.5,3.8,2.5,6.4C19.8,12.8,19,14.7,17.6,16.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,13c-0.6,0-1.1-0.2-1.6-0.6c-0.4-0.4-0.7-0.9-0.7-1.6c0-0.6,0.2-1.1,0.7-1.5c0.4-0.4,1-0.7,1.6-0.7 c0.6,0,1.1,0.2,1.6,0.6c0.4,0.4,0.7,0.9,0.7,1.6c0,0.6-0.2,1.1-0.7,1.5C12.1,12.8,11.6,13,11,13L11,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.70c7edb156c532b15c9ebfd4fc1aa5ee.svg";
export { ForwardRef as ReactComponent };